import { Component, Input, OnInit } from '@angular/core';
import { BikeStatisticBike, ReturnRentedStatisticBikes } from '../../../../models/BikeStatistic';

@Component({
    selector: 'app-bike-statistics-return-rented-card-item',
    templateUrl: './bike-statistics-return-rented-card-item.component.html',
    styleUrls: ['./bike-statistics-return-rented-card-item.component.scss'],
    standalone: false
})
export class BikeStatisticsReturnRentedCardItemComponent implements OnInit {

  @Input() bikeItems: ReturnRentedStatisticBikes[];

  constructor() { }

  ngOnInit(): void {
  }

}
